import React from "react";

import iosss from "../../assets/mobile/mobile_app.png";
import AppleLogo from "../../assets/mobile/ios_download.svg"; // Adjust path as needed
import AndroidLogo from "../../assets/mobile/android_download.png"; // Adjust path as needed
import "./MobileAppSection.css"; // Import the CSS file

const MobileAppSection = () => {
  return (
    <section className="mobile-app-section">
      <h2 className="title1">Diamond Trading Simplified</h2>

      <p className="description1">
        Discover, explore, and purchase premium diamonds anytime, anywhere with
        our mobile app.
      </p>

      <div className="grid-container">
        {/* App Features */}
        <div className="features1">
          <h3 className="features-title">
            Enhance Your Diamond Buying Experience
          </h3>
          <ul className="features-list">
            <li>Explore an exclusive collection of certified diamonds</li>
            <li>
              View high-resolution images, videos and detailed specifications
            </li>
            <li>Get instant price quotes and real-time order updates</li>
            <li>Access personalized deals and industry insights</li>
            <li>Connect with our expert support team 24/7</li>
          </ul>
          <p className="cta-text">
            Download now and take your diamond business to the next level.
          </p>
        </div>

        {/* Mobile Screenshots & Download Buttons */}
        <div className="app-screenshots">
          <div className="image-container">
            <div className="relative flex items-center overflow-hidden">
              <img src={iosss} className="ios-image" alt="App Screenshot" />
            </div>
          </div>

          <div className="download-buttons">
            <a
              href="https://apps.apple.com/in/app/pansuriyaimpex/id816052131"
              className="download-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={AppleLogo}
                alt="Download on the App Store"
                width={160}
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.digitize.diamond&pcampaignid=web_share"
              className="download-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={AndroidLogo} alt="Get it on Google Play" width={180} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileAppSection;
